import { LoadState } from "../../constants/enums";
import { IActionItemCategories } from "./ActionItemCategory.types";


export const initialActionItemCategories: IActionItemCategories = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};

export const initialActionItemCategory = {
  action_item_category_uuid: null,
  category_code: "",
  category_name: "",
  description: "",
  status: "ACTIVE" as "ACTIVE" | "INACTIVE",
  is_default: 0,
  company_outlet_uuid: null,
};






